import Api from '../Utils/Axios';

export const postLogin = async (data) => {
  const response = await Api.post('admin/auth/login', data);
  return response.data;
};
